import React, { useState } from "react";
import classNames from "classnames";
import { ReactComponent as SearchIcon } from "assets/img/icons/search.svg";
import { CSSTransition } from "react-transition-group";
import ClickAwayListener from "react-click-away-listener";
import SearchInputField from "components/SearchInputField";
import { useHistory } from "react-router-dom";
import { useGlobalContext } from "store/contexts/globalContext";
import { useParams } from "react-router-dom";

function GlobalSearch({ team }) {
  const history = useHistory();
  const { setGlobalSearch } = useGlobalContext();
  const [showSearch, setSearch] = useState(false);
  const { teamId } = useParams();

  const handleSearch = () => {
    setSearch(!showSearch);
  };

  const closeSearch = () => {
    setSearch(false);
  };

  const handleSearched = async (searchValue) => {
    setSearch(false);
    setGlobalSearch(searchValue);
    if (teamId) {
      history.push(`/teams/${team?.id}/search`);
      return;
    }

    history.push("/search");
  };

  return (
    <div style={{ position: "relative" }}>
      <p
        onClick={handleSearch}
        className={classNames({
          "search_icon collapsed": true,
          //eslint-disable-next-line
          [" " + "active"]: showSearch && true,
        })}
      >
        <SearchIcon className="rightHeaderSearchIcon" />
      </p>
      <CSSTransition
        in={showSearch}
        timeout={300}
        unmountOnExit
        classNames="dropdown-element"
      >
        <ClickAwayListener onClickAway={closeSearch}>
          <div className="searchBar">
            <SearchInputField
              handleSearched={handleSearched}
              // className={"searchBar"}
            />
          </div>
        </ClickAwayListener>
      </CSSTransition>
    </div>
  );
}

export default GlobalSearch;
